module.exports = __webpack_public_path__ + "img/estagiario.4592cfad.png";